import { render, staticRenderFns } from "./GameGallery.vue?vue&type=template&id=28bce3a0"
import script from "./GameGallery.vue?vue&type=script&lang=js"
export * from "./GameGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports